import styles from './custom-table-header.module.scss';
import { Flex } from 'antd';
import ArrowTopRight from '@/assets/icons/arrow-up-right.svg?react';
import ArrowDownRight from '@/assets/icons/arrow-down-right.svg?react';
import Icon from '@ant-design/icons';

interface CustomTableHeaderProps {
  count: number;
  change?: number;
  textHeader1?: string;
  textHeader2?: string;
}

export const CustomTableHeader = ({
  count,
  change,
  textHeader1,
  textHeader2,
}: CustomTableHeaderProps) => {
  const isPositive = change && change > 0;

  const ArrowIcon = isPositive ? ArrowTopRight : ArrowDownRight;
  return (
    <Flex gap={10} align="end" justify="flex-start" className={styles.container}>
      <p className={styles.callsText}>
        {textHeader1}
        <br />
        {textHeader2}
      </p>

      <Flex
        style={{ color: styles.iconColor }}
        align="flex-start"
        className={styles.countContainer}
      >
        <p className={styles.count}>{count}</p>
        {change && (
          <>
            <Icon component={() => <ArrowIcon width="20" height="20" />} />
            <span className={styles.change}>{`${change}%`}</span>
          </>
        )}
      </Flex>
    </Flex>
  );
};
